(function () {
  angular.module('lif.controllers').controller('meetingsBlockController', meetingsBlockController).directive('ngDateTimePicker', dateTimePickerDirective).filter('dateWithFullMonthName', dateWithFullMonthNameFilter);
  meetingsBlockController.$inject = ['$rootScope', '$scope', '$location', '$timeout', '$window', 'formService', 'meetingsBlockBootstrap', 'userService'];

  function meetingsBlockController($rootScope, $scope, $location, $timeout, $window, formService, meetingsBlockBootstrap, userService) {
    var contentGuid = meetingsBlockBootstrap.contentGuid;
    $scope.activeCategories = [];
    $scope.unselectedFiles = [];
    $scope.categoryPrefix = 'category_';
    $scope.yearMeetingPrefix = 'year_';
    $scope.editMeetingDetailsMode = false;
    $scope.confirmDeleteMeeting = false;
    $scope.confirmDeleteFile = false;
    $scope.fileEditMode = false;
    $scope.addFileData = {};
    $scope.savingMeetingDetails = false;
    $scope.dateFormat = 'dd/MM/yyyy';
    $scope.sortableOptions = {
      disabled: true,
      axis: 'y'
    };
    $scope.fileDownloadIds = '';
    var vm = this;
    var errorMessageTimeout = 5000;

    vm.init = function () {
      var locationSearch = $location.search();
      var urlMeetingId = locationSearch.meeting;
      formService.getAllMeetings(contentGuid).then(function (result) {
        $scope.meetings = result.data.Meetings;
        $scope.uniqueYears = result.data.MeetingYears;
        getYearMeetings();

        if (urlMeetingId != null && urlMeetingId != '') {
          initMeetingDetailsModal(urlMeetingId);
        }
      }, function () {});
    };

    var updateFilesToDownload = function updateFilesToDownload() {
      var filesToRemove = Object.keys($scope.unselectedFiles);
      var filesToDownload = [];
      $scope.showingFiles.forEach(function (itm) {
        if (filesToRemove.indexOf(itm.Id) === -1) {
          filesToDownload.push(itm.Id);
        }
      });
      $scope.fileDownloadIds = filesToDownload.join(',');
    };

    vm.showAddMeetingModal = function () {
      vm.meetingTitle = '';
      vm.meetingStartTime = '';
      vm.meetingEndTime = '';
      $('#addMeetingModal').modal('show');
    };

    vm.allFieldsValid = function () {
      var title = vm.meetingTitle;
      var titleValid = title && title != '';
      var startTime = vm.meetingStartTime;
      var startTimeValid = startTime && startTime != '';
      var endTime = vm.meetingEndTime;
      var endTimeValid = endTime && endTime != '';
      return titleValid && startTimeValid && endTimeValid;
    };

    vm.createMeeting = function () {
      vm.creatingMeeting = true;
      var data = {
        title: vm.meetingTitle,
        start: formatDate(vm.meetingStartTime),
        end: formatDate(vm.meetingEndTime),
        fileFilterCategories: []
      };
      formService.createMeeting(contentGuid, data).then(function () {
        updateMeetingsList();
        vm.creatingMeeting = false;
        $('#addMeetingModal').modal('hide');
      }, function () {
        // Show error info
        $scope.errorCreatingMeeting = true;
        vm.creatingMeeting = false;
        $timeout(function () {
          $scope.errorCreatingMeeting = false;
        }, errorMessageTimeout);
      });
    };

    vm.showMeetingDetailsModal = function (selectedMeeting) {
      var selectedMeetingFileFilterCategories = selectedMeeting.FileFilterCategories;

      if (selectedMeetingFileFilterCategories.length == 1) {
        $scope.categories = selectedMeetingFileFilterCategories[0].split('\n');
      } else {
        $scope.categories = selectedMeetingFileFilterCategories;
      }

      formService.getDetailsForMeeting(selectedMeeting.ContentGuid).then(function (result) {
        $scope.activeCategories = [];
        $scope.selectedMeeting = result.data;
        var meetingDetails = result.data;
        $scope.fileList = meetingDetails.Files;
        $scope.showingFiles = $scope.fileList;
        updateFilesToDownload();
        $('#meetingDetailsModal').modal('show');
        resizeMeetingDetailsModalSidebar();
        var locationSearch = $location.search();
        var urlActiveCategories = locationSearch.activeCategories;

        if (urlActiveCategories != null && urlActiveCategories != '') {
          urlActiveCategories.split(',').map(vm.toggleCategory);
        }

        $scope.meetingUrl = $location.search({
          meeting: selectedMeeting.ContentGuid
        }).absUrl();
      }, function () {
        $scope.selectedMeeting = null;
      });
    };

    vm.toggleCategory = function (categoryId) {
      var categoryKey = $scope.categoryPrefix + categoryId;
      var categoryKeyIndex = $scope.activeCategories.indexOf(categoryKey);

      if (categoryKeyIndex == -1) {
        $scope.activeCategories.push(categoryKey);
      } else {
        $scope.activeCategories.splice(categoryKeyIndex, 1);
      }

      if ($scope.activeCategories.length == 0) {
        $scope.showingFiles = $scope.fileList;
      } else if ($scope.fileList != null) {
        $scope.showingFiles = $scope.fileList.filter(function (file) {
          var fileCategories = file.Categories;

          for (var i = 0; i < fileCategories.length; i++) {
            if ($scope.activeCategories.indexOf($scope.categoryPrefix + fileCategories[i]) != -1) {
              return true;
            }
          }

          return false;
        });
      }

      resizeMeetingDetailsModalSidebar();
      updateFilesToDownload();
    };

    vm.showAllCategories = function () {
      $scope.activeCategories = [];
      $scope.showingFiles = $scope.fileList;
      resizeMeetingDetailsModalSidebar();
      updateFilesToDownload();
    };

    vm.toggleSelectFile = function (file) {
      if (!$scope.unselectedFiles[file.Id]) {
        $scope.unselectedFiles[file.Id] = true;
      } else {
        $scope.unselectedFiles[file.Id] = false;
      }

      updateFilesToDownload();
    };

    vm.showFileOptions = function (event, fileId) {
      $scope.selectedFileId = fileId;
      var trigger = angular.element(event.target);
      var triggerOffset = trigger.offset();
      var containerElement = trigger.offsetParent();
      var containerElementOffset = containerElement.offset();
      $('#meeting-file-options').css({
        top: triggerOffset.top - containerElementOffset.top,
        left: triggerOffset.left - containerElementOffset.left
      });
      $scope.showingFileOptions = true;
    };

    vm.copyMeetingUrl = function () {
      var activeCategoryString = $scope.activeCategories.join(',').replace(new RegExp($scope.categoryPrefix, 'g'), '');
      $location.search({
        meeting: $scope.selectedMeeting.ContentGuid,
        activeCategories: activeCategoryString
      });
      $scope.meetingUrl = $location.absUrl();
      var $temp = $('<input>');
      $('body').append($temp);
      $temp.val($scope.meetingUrl).select();
      document.execCommand('copy');
      $temp.remove();
    };

    vm.saveMeetingDetails = function () {
      $scope.savingMeetingDetails = true;
      var oldMeetingDetails = $scope.selectedMeeting;
      $scope.selectedMeeting.Title = $scope.newName;
      $scope.selectedMeeting.Start = formatDate(new Date($scope.newMeetingStartTime));
      $scope.selectedMeeting.End = formatDate(new Date($scope.newMeetingEndTime));
      saveChangedMeeting(oldMeetingDetails);
    };

    vm.saveMeetingFileOrder = function () {
      saveChangedMeeting($scope.selectedMeeting);
      $scope.fileEditMode = false;
      vm.showAllCategories();
    };

    vm.deleteMeeting = function () {
      formService.deleteMeeting($scope.selectedMeeting.ContentGuid).then(function () {
        // Show deleted info
        $scope.confirmDeleteMeeting = false;
        $scope.selectedMeeting = null;
        updateMeetingsList();
      }, function () {
        // Show error info
        $scope.errorDeletingMeeting = true;
        $timeout(function () {
          $scope.errorDeletingMeeting = false;
        }, errorMessageTimeout);
      });
    };

    vm.deleteFile = function () {
      vm.isBusy = true;
      formService.deleteMeetingFile($scope.fileToDelete.Id).then(function () {
        // success
        $scope.confirmDeleteFile = false;
        vm.isBusy = false; // update file list

        vm.showMeetingDetailsModal($scope.selectedMeeting);
      }, function () {
        // error
        $scope.confirmDeleteFile = false;
        vm.isBusy = false;
      });
    };

    vm.turnOnEditMeetingDetailsMode = function () {
      vm.cancelEditModes();
      $scope.editMeetingDetailsMode = true;
      $scope.newName = $scope.selectedMeeting.Title;
      $scope.newMeetingStartTime = new Date($scope.selectedMeeting.Start);
      $scope.newMeetingEndTime = new Date($scope.selectedMeeting.End);
    };

    vm.turnOnDeleteMeeting = function () {
      vm.cancelEditModes();
      $scope.confirmDeleteMeeting = true;
    };

    vm.confirmDeleteFile = function (file) {
      vm.cancelEditModes();
      $scope.fileToDelete = file;
      $scope.confirmDeleteFile = true;
    };

    vm.turnOnFileEditMode = function (isEditMode) {
      vm.cancelEditModes();
      $scope.fileEditMode = true;
      $scope.sortableOptions.disabled = false;
      $scope.oldFileList = angular.copy($scope.fileList);
      $scope.showingFiles = $scope.fileList;
      vm.showAllCategories();
      updateFilesToDownload();
    };

    vm.cancelFileEditMode = function () {
      vm.cancelEditModes();
      $scope.fileList = $scope.oldFileList;
      $scope.showingFiles = $scope.fileList;
      updateFilesToDownload();
    };

    vm.cancelEditModes = function () {
      $scope.fileEditMode = false;
      $scope.sortableOptions.disabled = true;
      $scope.editMeetingDetailsMode = false;
      $scope.confirmDeleteMeeting = false;
      $scope.confirmDeleteFile = false;
      $scope.meetingAddFileMode = false;
    };

    vm.inEditMode = function () {
      return $scope.editMeetingDetailsMode || $scope.confirmDeleteMeeting;
    };

    vm.turnOnMeetingAddFileMode = function () {
      $scope.addFileData = {};
      $scope.meetingAddFileMode = true;
    };

    vm.turnOnMeetingFileEditMode = function (file) {
      $scope.addFileData.categories = file.Categories;
      $scope.meetingEditFileMode = true;
      $scope.fileToEdit = file;
    };

    vm.inAddEditFileMode = function () {
      return $scope.meetingAddFileMode || $scope.meetingEditFileMode || $scope.confirmDeleteFile;
    };

    vm.updateMeetingFile = function () {
      $scope.meetingEditFileMode = false;
      saveChangedMeeting();
    };

    vm.addFileToMeeting = function () {
      $scope.showUploadFileErrorMessage = false;
      $scope.showUploadFileCategoriesErrorMessage = false;

      if ($scope.addFileData.categories == undefined) {
        $scope.showUploadFileCategoriesErrorMessage = true;
      } else if ($scope.fileToUpload !== undefined && $scope.fileToUpload != null && $scope.addFileData.categories != undefined) {
        $scope.uploadFileName = $scope.fileToUpload.name;
        vm.isBusy = true;
        formService.uploadMeetingFile($scope.selectedMeeting.ContentGuid, $scope.fileToUpload, $scope.addFileData.categories).then(function (result) {
          vm.isBusy = false; // update file list

          vm.showMeetingDetailsModal($scope.selectedMeeting);
          var event = {
            Date: new Date().toJSON().slice(0, 10),
            Message: "Lade till " + $scope.uploadFileName + " i " + $scope.selectedMeeting.Title,
            User: userService.getLoggedInUser().name,
            Id: undefined
          };
          $rootScope.$broadcast('groupEvent', event);
          $scope.fileToUpload = null;
          $scope.meetingAddFileMode = false;
        }, function (result) {
          //error
          vm.isBusy = false;
          $scope.fileToUpload = null;

          if (result.status == 400) {
            $scope.showUploadFileErrorMessage = true;
          }
        });
      }
    };

    vm.getFileTypeIcon = function (fileName) {
      return fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase() + '.png';
    };

    angular.element('#meetingDetailsModal').on('hidden.bs.modal', function () {
      vm.cancelEditModes();
      $location.search({});
      $scope.$apply();
    });
    angular.element('#meetingDetailsModal').on('shown.bs.modal', function () {
      resizeMeetingDetailsModalSidebar();
    });

    function formatDate(date) {
      var mm = date.getMonth() + 1;
      var dd = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var formatted = [date.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
      formatted += 'T' + ((hours > 9 ? '' : '0') + hours) + ':' + ((minutes > 9 ? '' : '0') + minutes) + ':00';
      return formatted;
    }

    ;

    function resizeMeetingDetailsModalSidebar() {
      resizeModalSidebar($('#meetingDetailsModal'));
    }

    function saveChangedMeeting(oldMeetingDetails) {
      var newData = {
        contentGuid: $scope.selectedMeeting.ContentGuid,
        title: $scope.selectedMeeting.Title,
        start: $scope.selectedMeeting.Start.toString(),
        end: $scope.selectedMeeting.End.toString(),
        fileFilterCategories: $scope.selectedMeeting.FileFilterCategories,
        files: $scope.selectedMeeting.Files,
        owningBlockId: $scope.selectedMeeting.OwningBlockId,
        owningGroupName: $scope.selectedMeeting.OwningGroupName
      };
      formService.saveMeetingDetails($scope.selectedMeeting.ContentGuid, newData).then(function () {
        // Show saved info
        $scope.editMeetingDetailsMode = false;
        updateMeetingsList();
        $scope.savingMeetingDetails = false;
      }, function () {
        if (oldMeetingDetails) {
          // Reset meeting details
          $scope.selectedMeeting = oldMeetingDetails;
        }

        $scope.savingMeetingDetails = false; // Show error info

        $scope.errorSavingChanges = true;
        $timeout(function () {
          $scope.errorSavingChanges = false;
        }, errorMessageTimeout);
      });
    }

    function updateMeetingsList() {
      formService.getAllMeetings(contentGuid).then(function (result) {
        $scope.uniqueYears = result.data.MeetingYears;
        $scope.meetings = result.data.Meetings;
        getYearMeetings();
      }, function () {});
    }

    function resizeModalSidebar(modal) {
      $timeout(function () {
        var modalContentHeight = modal.find('.modal-content').outerHeight();
        var modalSidebar = modal.find('.modal-sidebar');
        modalSidebarHeaderHeight = modalSidebar.find('.modal-sidebar-header').outerHeight();
        modalSidebar.find('.meetingsblock-calendar-list').height(modalContentHeight - modalSidebarHeaderHeight);
      }, 0, false);
    }

    function initMeetingDetailsModal(meetingId) {
      for (var key in $scope.meetings) {
        var meeting = $scope.meetings[key];

        if (meeting.ContentGuid == meetingId) {
          vm.showMeetingDetailsModal(meeting);
          return;
        }
      }
    }

    ;

    function getYearMeetings() {
      $scope.yearMeetings = [];

      for (var key in $scope.meetings) {
        var meeting = $scope.meetings[key];
        var meetingYear = new Date(meeting.Start).getFullYear();

        if (!$scope.yearMeetings[$scope.yearMeetingPrefix + meetingYear]) {
          $scope.yearMeetings[$scope.yearMeetingPrefix + meetingYear] = [];
        }

        $scope.yearMeetings[$scope.yearMeetingPrefix + meetingYear].push(meeting);
      }
    }

    function getUniqueYears(meetings) {
      var result = {};
      var years = [];
      var item;

      for (var key in meetings) {
        item = meetings[key];
        var year = new Date(item.Start).getFullYear();

        if (!result['year_' + year]) {
          years.push('' + year);
          result['year_' + year] = [];
        }

        result['year_' + year].push(item);
      }

      $scope.uniqueYears = years;
      $scope.yearMeetings = result;
    }

    ;
    $scope.$watch('fileToUpload', function () {
      if ($scope.fileToUpload !== undefined && $scope.fileToUpload != null) {
        $scope.uploadFileName = $scope.fileToUpload.name;
      } else {
        $scope.uploadFileName = '';
      }
    });
    $(window).resize(function () {
      resizeModalSidebar($('#meetingDetailsModal'));
    });
  }

  ;

  function dateTimePickerDirective() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function link(scope, element, attrs, ngModelCtrl) {
        var format = 'DD/MM/YYYY';
        var dateTimePicker = $(element).datetimepicker({
          format: format,
          focusOnShow: false,
          ignoreReadonly: true,
          locale: 'sv',
          widgetPositioning: {
            horizontal: 'auto',
            vertical: 'bottom'
          }
        });
        dateTimePicker.on('dp.change', function (e) {
          ngModelCtrl.$setViewValue(new Date(e.date));
          scope.$apply();
        });
      }
    };
  }

  ;

  function dateWithFullMonthNameFilter() {
    return function (input, inEnglish) {
      var monthFullNames;

      if (inEnglish.toLowerCase() == 'false') {
        monthFullNames = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'];
      } else {
        monthFullNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      }

      var dateInput = new Date(input);
      var date = dateInput.getDate();
      var monthName = monthFullNames[dateInput.getMonth()];
      var year = dateInput.getFullYear();
      return date + ' ' + monthName + ' ' + year;
    };
  }

  ;
  $(document).ready(function () {
    $(document).on("click", ".meetingsblock-calendar-year-header", function () {
      var id = $(this).data('title');
      $("[data-title='".concat(id, "']")).parent().children().not(".meetingsblock-calendar-year-header").toggleClass("hidden");
    });
  });
})();